import React, { useState } from "react";
import "./ThreeDBook.css";

function ThreeDBook({ book }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const handleBookClick = () => {
    setIsOpen((prev) => !prev);
    if (!isOpen) setCurrentPage(0);
  };

  const handleNextPage = (e) => {
    e.stopPropagation();
    if (currentPage + 1 < book.pages.length) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = (e) => {
    e.stopPropagation();
    if (currentPage - 1 >= 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="book-container" onClick={handleBookClick}>
      <div className={`book ${isOpen ? "open" : ""}`}>
        <div className="book-spine" />

        {!isOpen && (
          <div className="book-cover-front">
            <div className="cover-title">{book.title}</div>
            <div className="cover-author">{book.author}</div>
          </div>
        )}

        {isOpen && (
          <>
            {/* Left Page */}
            <div className="book-left-page">
              <p>{book.pages[currentPage] || ""}</p>
              <div className="page-number-left">Page {currentPage + 1}</div>
            </div>

            {/* Right Page */}
            <div className="book-right-page">
              <p>{book.pages[currentPage + 1] || ""}</p>
              {book.pages[currentPage + 1] && (
                <div className="page-number-right">Page {currentPage + 2}</div>
              )}
            </div>

            {/* Navigation buttons */}
            {currentPage > 0 && (
              <button className="page-btn prev-btn" onClick={handlePrevPage}>
                ◀
              </button>
            )}
            {currentPage + 1 < book.pages.length && (
              <button className="page-btn next-btn" onClick={handleNextPage}>
                ▶
              </button>
            )}
          </>
        )}

        <div className="book-cover-back" />
      </div>
    </div>
  );
}

export default ThreeDBook;
